import getInstances from 'app/games/hangedman/selectors/getInstances';

function getInstance(state, id) {
  return getInstances(state).find(instance => instance.id === id);
}

export default getInstance;
